import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles } from 'utils-next/types'

import { Card, Divider, Theme } from '@mui/material'

import { SearchEngineContent } from './SearchEngineContent.component'
import { SearchEngineHeader } from './SearchEngineHeader.component'

export type SearchEngineProps = ExtendableStyles

export function SearchEngine({ className, style }: SearchEngineProps) {
  const { classes } = useStyles()
  return (
    <Card className={classNames(className, classes.content)} style={style}>
      <SearchEngineHeader />
      <Divider />
      <SearchEngineContent />
    </Card>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minHeight: spacing(50),
  },
  header: {
    position: 'relative',
    width: '100%',
  },
}))
